<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-md-space-between align-center flex-wrap justify-center">
        <div class="d-flex align-center">
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Calendario Visite Mediche</h2>
          <h3 class="mx-3" v-else>Calendario Visite Mediche</h3>
        </div>
        <div class="d-flex align-center justify-end" >
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">{{clockDate}} {{clockTime}}</h2>
          <h3 class="mx-3" v-else>{{clockDate}} {{clockTime}}</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <v-progress-linear color="primary" class="w-100" indeterminate v-if="loading" height="2"></v-progress-linear>
        <v-divider class="mb-3" v-else></v-divider>
      </v-col>

      <v-col cols="12">
        <div class="booking-calendar border rounded w-100" >
          <v-table density="compact" striped="even" >
            <thead>
            <tr>
              <th colspan="2">
                <div class="w-100 d-flex flex-column flex-md-row justify-space-between align-center py-3">
                  <div class="d-flex align-center my-1 my-md-0">
                    <v-btn color="primary" :disabled="isToday || loading" @click="setToday()">Vai a oggi</v-btn>
                    <v-btn color="primary" icon="mdi-chevron-left" class="mx-2" size="small" @click="prevDay()" :disabled="loading"></v-btn>
                    <v-btn color="primary" icon="mdi-chevron-right" size="small" @click="nextDay()" :disabled="loading"></v-btn>
                  </div>

                  <div class=" my-1 my-md-0">
                    <h2 v-if="$vuetify.display.lgAndUp">{{formatDateExtended(date)}}</h2>
                    <h3 v-else>{{formatDateExtended(date)}}</h3>

                    <div class="d-flex justify-center">
                      <v-chip  color="primary" density="compact" class="mx-1" v-if="isToday">OGGI</v-chip>
                      <v-chip variant="flat" density="compact" color="error" class="mx-1" v-if="isClosed">CHIUSURA</v-chip>
                    </div>
                  </div>


                  <div class="d-flex align-center my-1 my-md-0">
                    <v-menu :close-on-content-click="false">
                      <template #activator="{props}">
                        <v-btn class="mr-2" variant="outlined" append-icon="mdi-chevron-down" v-bind="props" :disabled="loading">{{formatDate(date)}}</v-btn>
                      </template>
                      <v-date-picker v-model="dateJs"></v-date-picker>
                    </v-menu>

                    <v-btn v-if="isEditor" color="primary" append-icon="mdi-plus" @click="openBookingDialog()" :disabled="loading || isClosed">Aggiungi</v-btn>
                  </div>




                </div>
                <v-progress-linear indeterminate color="primary" v-if="loading" class="w-100"></v-progress-linear>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-if="!hours.length || isClosed">
              <td colspan="2" class="text-center font-italic py-4">
                Non ci sono ore prenotabili per questa giornata
              </td>
            </tr>
            <tr v-if="!isClosed" v-for="hour in hours" :key="hour.date.toISO()!" :id="isCurrentTime(hour.time) ? 'current-hour' : undefined" :class="isCurrentTime(hour.time) ? 'bg-blue-lighten-3' : ''">
              <td style="width: 100px" class="border-e">
                <strong>Ore {{hour.time}}</strong>
              </td>
              <td>
                <div class="d-flex flex-wrap w-100">
                  <v-card v-for="evt in hour.events" :key="evt._id" class="ma-1" variant="outlined" :class="isCurrentTime(hour.time) ? 'bg-primary' : ''" @click="selectedEvent = evt; eventDialog = true">
                    <v-card-text>
                      <h4>{{evt.title}}</h4>
                      <p>ore <strong>{{evt.when.toFormat("HH:mm")}}</strong></p>
                    </v-card-text>
                  </v-card>
                </div>
              </td>
            </tr>
            </tbody>
          </v-table>

          <v-dialog v-model="addBookingDialog" max-width="600">
            <v-card>
              <v-form ref="form" @submit.prevent="addBooking()" >
                <v-card-title>
                  <h3>Aggiungi prenotazione</h3>
                </v-card-title>
                <v-card-text>
                  <v-row class="mt-2">
                    <v-col cols="12" >
                      <v-autocomplete label="Utente" :items="userOptions" v-model="newItem.user_id"
                                      :rules="[rules.required]">


                        <template v-slot:selection="{item}">
                          <div>
                            <h4 class="mb-0" style="line-height: 1.1" >{{item.title}}</h4>
                            <p class="text-caption text-grey-darken-3" style="line-height: 1">{{item.fiscal_code}}</p>
                          </div>


                        </template>

                        <template v-slot:item="{props, item}">
                          <v-list-item v-bind="props" :subtitle="item.fiscal_code"></v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-text-field label="Data" type="date" v-model="bookingDate" clearable :rules="[rules.required]" :hint="bookingDateFormat" persistent-hint/>
                    </v-col>

                    <v-col cols="12" lg="6">
                      <v-autocomplete label="Ora" v-model="bookingTime" clearable :rules="[rules.required]" :disabled="!bookingDate" :items="bookingHoursOptions"/>
                    </v-col>



                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="addBookingDialog = false">Chiudi</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" variant="elevated" type="submit">Inserisci prenotazione</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog v-model="eventDialog" max-width="800">
            <v-card>
              <v-card-text v-if="selectedEvent">
                <h2 class="mb-3">Dettaglio prenotazione</h2>
                <h3 class="mb-3">Utente: <span class="text-info">{{selectedEvent.title}}</span></h3>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="eventDialog = false;">Chiudi</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="selectedEvent && isEditor" color="error" variant="elevated" @click="removeBooking(selectedEvent)" :disabled="loading" :loading="loading">Elimina prenotazione</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
      <v-col cols="12" v-if="isAdmin"><h3>Date disponibili</h3></v-col>
      <v-col cols="12" lg="6" v-if="isAdmin">
        <v-table class="border rounded" striped="even">
          <thead>
          <tr>
            <th>Data</th>
            <th>Dalle</th>
            <th>Alle</th>
            <th style="width: 60px" class="text-center">Azioni</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="!medicalHours.length">
            <td colspan="4" class="text-center font-italic">Al momento non sono previste date per visite mediche</td>
          </tr>
          <tr v-for="(h, i) in medicalHours" :key="h._id" >

            <td>{{formatDate(h.from)}}</td>
            <td>{{formatTime(h.from)}}</td>
            <td>{{formatTime(h.to)}}</td>
            <td style="width: 60px" class="text-center">
              <v-btn variant="text" icon="mdi-close" color="error" @click="removeHour(h._id!)"></v-btn>
            </td>
          </tr>
          </tbody>
        </v-table>
      </v-col>
      <v-col cols="12" lg="6">
        <v-row>
          <v-col cols="12"><h4>Aggiungi una data per le visite mediche</h4></v-col>
          <v-col cols="12" md="4" lg="6" >
            <v-text-field type="date"  label="Data" v-model="availDate" hide-details/>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-text-field type="time"  label="Dalle" v-model="availFrom" :disabled="!availDate" hide-details/>
          </v-col>
          <v-col cols="12" md="4" lg="3">
            <v-text-field type="time"  label="Alle" v-model="availTo" :disabled="!availDate" hide-details/>
          </v-col>
          <v-col cols="12" lg="4">
            <v-btn color="primary" @click="addHour()" :disabled="!availFrom || !availTo || !availDate || loading" :loading="loading">Inserisci</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>


  </v-container>
</template>

<script lang="ts">
import utils from '../utils';
import {
  type MedicalCalendarBooking, type MedicalEvent,
  type MedicalHour, type MedicalTime,
  SeatsType
} from '@/models.ts'
import {DateTime} from "luxon";
import {computed, inject, onBeforeUnmount, onMounted, type PropType, ref, useTemplateRef, watch} from "vue";
import type {Globals} from "@/plugins/globals.ts";
import api from "@/api";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import BookingCalendar from "@/components/BookingCalendar.vue";
import SeatsCalendar from "@/components/SeatsCalendar.vue";
import type {VForm} from "vuetify/components";
import rules from "@/utils/rules.ts";

export default {
  components : {SeatsCalendar, BookingCalendar },
  setup(props, ctx) {

    const auth = inject('auth') as Auth
    const globals = inject('globals') as Globals
    const messages = inject('messages') as Messages

    let clock:any
    const clockDate = ref('')
    const clockTime = ref('')

    const loading = ref(false)

    const medicalHours = ref<MedicalHour[]>([])

    const addBookingDialog = ref(false)
    const date = ref<DateTime>(DateTime.now())
    const eventDialog = ref(false)
    const selectedEvent = ref<MedicalEvent|undefined>()
    const holidays = ref<Record<string, boolean>>({})

    const form = useTemplateRef<typeof VForm>('form')

    const bookings = ref<MedicalCalendarBooking[]>([])

    const newHour = ref<MedicalHour>({
      from : DateTime.now().set({hour: 14, minute : 0}).toISO(),
      to : DateTime.now().set({hour: 20, minute : 0}).toISO(),
    })

    const availDate = ref<string|undefined>(DateTime.now().toISODate())
    const availFrom = ref<string|undefined>("14:00")
    const availTo = ref<string|undefined>("20:00")

    const newItem = ref<MedicalCalendarBooking>({
      user_id: "", when: ""
    })
    const bookingDate = ref<string>('')
    const bookingTime = ref<string>('')

    const loadBookingData = async () => {
      loading.value = true;

      const res = await api.list<MedicalCalendarBooking>('medicalbooking', { from : date.value.toISODate(), to : date.value.toISODate() }, 0, 0, '+date')
      loading.value = false;
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
        return
      }
      bookings.value = res.data ?? []
    }


    const events = computed<MedicalEvent[]>(()=>{
      return bookings.value.map(item => {

        const user = globals.users.value.find(i => i._id === item.user_id)
        let when = utils.toDateTime(item.when)
        let evt:MedicalEvent = {
          _id : item._id!,
          title : `${user?.name} ${user?.surname}`,
          when,
          item
        }
        return evt
      })
    })

    const refreshHours = async () => {
      loading.value = true;
      const res = await api.list<MedicalHour>('medicalhours', {  }, 0, 0, '+time')
      loading.value = false
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
        return
      }
      medicalHours.value = res.data ?? []
    }



    const times = computed<MedicalTime[]>(()=>{
      const base = medicalHours.value.filter(mh => {
        const from = DateTime.fromISO(mh.from)
        const to = DateTime.fromISO(mh.to)
        if(!from.isValid || !to.isValid) return false;
        if(from >= to) return false
        return date.value.toISODate() === from.toISODate()
      })
      let items:MedicalTime[] = []
      for(let i = 0; i < base.length; i++) {
        const to = DateTime.fromISO(base[i].to)!
        let current = DateTime.fromISO(base[i].from)!
        while (current < to) {
          items.push({
            date : current,
            time : current.toFormat("HH:mm")
          })
          current = current.plus({minute:10})
        }
      }
      return items;
    })

    const hours = computed(()=>{
      return times.value.map(time => {
        return {
          ...time,
          events : events.value.filter(e => {
            return e.when.toFormat("HH:mm") === time.time
          })
        }
      })
    })

    const checkIfHoliday = async () => {
      const value = date.value.toISODate()!
      if(holidays.value[value] !== undefined) return
      const res = await api.get<boolean>('holidays', `check/${value}`)
      if(res.data !== undefined) holidays.value[value] = res.data
    }

    const isToday = computed(()=>{
      return date.value.toISODate() === DateTime.now().toISODate()
    })


    let wh:any;
    onMounted(async ()=>{
      await auth.waitForLogin
      await globals.waitForInit

      clock = setInterval(()=>{
        let now = DateTime.now();
        clockDate.value = now.toFormat('DDD')
        clockTime.value = now.toFormat('HH:mm:ss')
        //if(calendarReady.value) cal.value?.updateTimes()
      },1000)

      wh = watch(date, async ()=>{
        await loadBookingData()
        await checkIfHoliday()
      })

      await Promise.all([
        globals.refresh('users'),
        refreshHours(),
      ])
      await loadBookingData()
      await checkIfHoliday()

    })
    onBeforeUnmount(async ()=>{
      if(wh) wh();
      clearInterval(clock)
    })


    return {
      isEditor : auth.isEditor,
      isAdmin : auth.isAdmin,
      clockDate,
      clockTime,
      loading,
      medicalHours,
      formatTime : utils.formatTime,
      formatDate : utils.formatDate,
      formatDateTime : utils.formatDateTime,
      formatDateExtended : utils.formatDateExtended,
      refreshHours,
      date,
      eventDialog,
      selectedEvent,
      addBookingDialog,
      hours,
      userOptions : computed(()=>{
        return globals.users.value.map(i => {
          return { title : `${i.name} ${i.surname}`, fiscal_code : i.fiscal_code, value : i._id}
        })
      }),
      dateJs : computed({
        get():Date{
          return date.value.toJSDate()
        },
        set(val:Date) {
          const dt = DateTime.fromJSDate(val)
          if(dt && dt.isValid) {
            date.value = dt!;
          }
        }
      }),
      isToday,
      isClosed : computed(()=>{
        if(holidays.value[date.value.toISODate()!] !== undefined) {
          return holidays.value[date.value.toISODate()!];
        }
        return false
      }),
      setToday() {
        date.value = DateTime.now();
      },
      prevDay() {
        date.value = date.value.plus({day:-1})
      },
      nextDay() {
        date.value = date.value.plus({day:1})
      },
      events,
      isCurrentTime(hour:string):boolean {
        if(!isToday.value) return false;
        const now = DateTime.now()
        const ht = DateTime.fromFormat(hour, "HH:mm")
        const endHt = DateTime.fromFormat(hour, "HH:mm").plus({minute:10})
        return now > ht && now < endHt
      },
      certStatusColor(status:'none'|'valid'|'expiring'|'expired') {
        switch (status) {
          case "none":
            return "error"
          case "valid":
            return "success"
          case "expired":
            return "error"
          case "expiring":
            return "warning"
        }
      },
      removeBooking(evt:MedicalEvent) {
        const dt = evt.when
        let date = dt.toFormat("EEEE dd/MM/yyyy 'alle' HH:mm")
        messages.requestConfirm("Richiesta conferma", `Sei sicuro di voler eliminare la prenotazione di <strong>${evt.title}</strong> per <strong>${date}</strong>`, false, async ok => {
          if(!ok) return

          loading.value = true
          const res = await api.del('medicalbooking', evt._id)
          loading.value = true
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
            return
          }
          messages.success("Prenotazione eliminata")
          await loadBookingData()
          eventDialog.value = false;
        })
      },
      form,
      rules,
      newItem,
      bookingDate,
      bookingDateFormat : computed(()=>{
        if(!bookingDate.value) return undefined
        const dt = DateTime.fromISO(bookingDate.value);
        if(!dt || ! dt.isValid) return undefined
        return dt.toFormat("EEEE dd MMMM yyyy")
      }),
      bookingTime,
      bookingHoursOptions : computed(()=>{
        return times.value.filter(t => {
          const item = bookings.value.find(i => {
            const dt = DateTime.fromISO(i.when)
            if(!dt.isValid) return false;
            return t.date.toFormat("dd/MM/yyyy HH:mm") === dt.toFormat("dd/MM/yyyy HH:mm")
          })
          return item === undefined
        }).map(t => {
          return {
            title : t.time,
            value : t.time
          }
        })
      }),
      openBookingDialog() {
        bookingDate.value = date.value.toISODate()!
        newItem.value = {user_id: '', when: ''}
        addBookingDialog.value = true
      },

      async addBooking() {
        const { valid } = await form.value!.validate()
        if(!valid) return;

        newItem.value.when = DateTime.fromFormat(`${bookingDate.value} ${bookingTime.value}`, 'yyyy-MM-dd HH:mm')!.toISO()!

        loading.value = true;
        const res = await api.post<MedicalCalendarBooking>('medicalbooking', newItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          return
        }
        await loadBookingData()
      },


      availDate,
      availFrom,
      availTo,
      async addHour() {
        const from = DateTime.fromFormat(`${availDate.value} ${availFrom.value}`, "yyyy-MM-dd HH:mm")
        const to = DateTime.fromFormat(`${availDate.value} ${availTo.value}`, "yyyy-MM-dd HH:mm")
        if(!from || !from.isValid || !to || !to.isValid || to <= from) {
          messages.error("Inserisci un range di date valide")
          return
        }
        newHour.value.from = from.toISO()!
        newHour.value.to = to.toISO()!

        loading.value = true
        const res = await api.post('medicalhours', newHour.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          return
        }
        await refreshHours()
        await loadBookingData()
      },
      removeHour(id:string) {
        messages.requestConfirm("Richiesta conferma", `Sei sicuro di voler eliminare questa data per le visite mediche?`, false, async ok => {
          if(!ok) return

          loading.value = true
          const res = await api.del('medicalhours', id)
          loading.value = true
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
            return
          }
          messages.success("Data eliminata")
          await refreshHours()
          await loadBookingData()
          eventDialog.value = false;
        })
      },
    }

  }

}
</script>